var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewmessagePageLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7155 9.28449C11.8054 8.37478 10.5713 7.86374 9.2845 7.86374C7.99771 7.86374 6.76359 8.37478 5.8535 9.28449L2.4214 12.7155C1.51129 13.6256 1 14.86 1 16.147C1 17.4341 1.51129 18.6685 2.4214 19.5786C3.3315 20.4887 4.56587 21 5.85295 21C7.14003 21 8.3744 20.4887 9.2845 19.5786L11 17.8631",
    stroke: "#2D5063",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28442 12.7155C10.1945 13.6252 11.4286 14.1362 12.7154 14.1362C14.0022 14.1362 15.2363 13.6252 16.1464 12.7155L19.5785 9.2845C20.4886 8.3744 20.9999 7.14003 20.9999 5.85295C20.9999 4.56587 20.4886 3.3315 19.5785 2.4214C18.6684 1.51129 17.4341 1 16.147 1C14.8599 1 13.6255 1.51129 12.7154 2.4214L10.9999 4.13689",
    stroke: "#2D5063",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmessagePageLink);
export default __webpack_public_path__ + "static/media/newmessage_page_link.ebacd180ec6e7b6fbad8ece8387022be.svg";
export { ForwardRef as ReactComponent };